import { render, staticRenderFns } from "./ProjectItemNumberDialog.vue?vue&type=template&id=969b3442&scoped=true&"
import script from "./ProjectItemNumberDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemNumberDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemNumberDialog.vue?vue&type=style&index=0&id=969b3442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969b3442",
  null
  
)

export default component.exports